/**
 * Devuelve una location sin data_ref, o null si no hace falta limpiar la URL.
 */
export function routeLocationWithoutDataRef(route) {
  if (!route.query || route.query.data_ref === undefined) {
    return null;
  }
  const query = { ...route.query };
  delete query.data_ref;
  return {
    path: route.path,
    query,
    hash: route.hash,
  };
}
